import React from 'react'
import PropTypes from 'prop-types'
import { BaseCheckBox, Item } from './CheckBox.styles'

/**
 * The CheckBox's component.
 */
const CheckBox = props => {
  const { accessibility, checked, disabled, label, name, onChange } = props

  return (
    <Item
      control={
        <BaseCheckBox
          checked={checked}
          color="primary"
          disabled={disabled}
          disableRipple
          inputProps={{ 'aria-label': accessibility.label }}
          name={name}
          size="small"
          onChange={onChange}
        />
      }
      disabled={disabled}
      label={label}
    />
  )
}

CheckBox.defaultProps = {
  accessibility: {
    label: 'checkbox'
  },
  checked: false,
  disabled: false,
  name: '',
  onChange: () => undefined
}
CheckBox.propTypes = {
  accessibility: PropTypes.shape({
    label: PropTypes.string
  }),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func
}

export default CheckBox
